/* eslint-disable no-unused-vars */
/* eslint-disable prefer-const */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from '@material-ui/pickers'
import moment from "moment";
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  
  root: {
    "& .MuiOutlinedInput-root": {
      background: '#fff',
      fontSize:"12px"
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#E9DEAE"
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#E9DEAE"
    },
    '&	.Mui-disabled': {
      backgroundColor: "#f3f5f9"
    },
    '&	.MuiFormHelperText-contained': {
      marginLeft: "0px",
      marginTop: "6px",
    marginBottom: "0px",
    marginRight: "0px",
    color: "#FFA222"
    },
   
  }
})

const CustomDatePickerFinancial = ({
  isDisabled,
  validationFn,
  isMandatory,
  markIfUnselected,
  value,minDate,
  // onError,
  resetAllVisitedFields,maxDate,
  ...props
}) => {
  const classes = useStyles();
  console.log(maxDate,"maxDate")

  let currentDate = moment(maxDate, "DD-MM-YYYY");
  let year = Number(currentDate.format("YYYY"));

  const [isVisited, setIsVisited] = useState(false);
  const shouldMarkRed =
    ((isMandatory && isVisited) || markIfUnselected) && !value && !isDisabled;
  const isValueValid = validationFn && value ? validationFn(value) : true;

  useEffect(() => {
    if (resetAllVisitedFields && isVisited)
      setIsVisited(false);
  }, [resetAllVisitedFields, isVisited])
  // const year=2024
  return (
    <DatePicker
      error={shouldMarkRed || !isValueValid}
      onBlur={() => setIsVisited(true)}
      isDisabled={isDisabled}
      style={{ borderColor: 'red', boxShadow: '0px' }}
      value={value}
      {...props}
      className={classes.root}
      // maxDate={new Date(`03-31-${year}`)}
      maxDate={maxDate}
      minDate={minDate}
    //  minDate={new Date()}
    //  onError={onError}
    />
  );
};

CustomDatePickerFinancial.propTypes = {
  isDisabled: PropTypes.bool,
  validationFn: PropTypes.func,
 // onError: PropTypes.func,
  isMandatory: PropTypes.bool,
  markIfUnselected: PropTypes.bool,
  value: PropTypes.object,
  resetAllVisitedFields: PropTypes.bool
};

export default CustomDatePickerFinancial;
